import React from 'react';
import { styled } from "@mui/material/styles";
import { Box } from '@mui/material';

const Root = styled(Box)(({ theme }) => ({
  boxShadow: '0px 0px 0px 1px #E0E0E0',
  padding: theme.spacing(2),
  borderRadius: '0.4em',
  backgroundColor: theme.palette.common.white,
}));

type GroupSummariesCardProps = React.ComponentPropsWithoutRef<'div'>

/**
 * Styled Box element used for a card type container for grouped information
 * @param props Passthrough props to the internal Box mui component
 * @constructor
 */
const GroupSummariesCard = (props: GroupSummariesCardProps) => {
  return <Root {...props} />
}

export { GroupSummariesCard };
